import { fetchDataAndProceed } from '../../config/utils';
import { METHOD_TYPES } from '../../config/constants';

export const getSessionFlowData = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/analytics/sessionFlowSankey', METHOD_TYPES.GET, data, callback, 60000);
};


// WEBPACK FOOTER //
// ./src/data/redux/session_flow_details/api.js